import { Review } from '@core/domain/models/review.model'
import { IncidentMetadata } from '@core/domain/models/reviewItemMetadata/incidentMetadata'
import { BuiltInImportSourceId } from '@core/domain/types/builtInImportSourceId'
import { ReviewItemType } from '@core/domain/types/reviewItemType.type'
import axios from 'axios'

interface DateFilter {
  startDate?: string
  endDate?: string
}

export class MdidApiClient {
  async createReviewSearch(
    review: Review,
    query: string,
  ): Promise<{
    query?: string
    filters?: string
    date: string
    reviewId: number
    importSourceId: string
    items: IncidentMetadata & { type: ReviewItemType.Incident }[]
    queryTranslation?: string
    url?: string
  }> {
    const results = await this.search({ query })
    return {
      query,
      date: new Date().toISOString(),
      reviewId: review.id,
      importSourceId: BuiltInImportSourceId.MDID,
      items: results.map((a) => ({
        ...a,
        type: ReviewItemType.Incident,
      })),
      url:
        'https://hpr-rps.hres.ca/mdi_results.php?q=' +
        encodeURIComponent(query),
    }
  }

  async search({
    query,
    dateFilter,
  }: {
    query: string
    dateFilter?: DateFilter
  }): Promise<IncidentMetadata[]> {
    return this.searchIncidents(query, dateFilter)
  }

  private async searchIncidents(
    query: string,
    dateFilter?: DateFilter,
  ): Promise<IncidentMetadata[]> {
    let incidents: IncidentMetadata[] = []
    const url = '/live-scraper/mdid'
    try {
      const response = await axios.post(
        url +
          `?query=${query}` +
          (dateFilter?.startDate ? `&startDate=${dateFilter.startDate}` : '') +
          (dateFilter?.endDate ? `&endDate=${dateFilter.endDate}` : ''),
      )
      incidents = response.data
    } catch (error) {
      console.error('Error fetching records from MDID API:', error)
      throw error
    }

    return incidents
  }
}
